import React, { useState } from 'react';
import Navigation from './Navigation';
import MobileBottomNav from './MobileBottomNav';
import CommandPalette from './CommandPalette';
import Breadcrumbs from './Breadcrumbs';
import OnboardingTour, { useTour } from './OnboardingTour';
import OnboardingWizard from './OnboardingWizard';
import KeyboardShortcuts from './KeyboardShortcuts';
import CopilotWidget from './CopilotWidget';
import ErrorState from './ErrorState';
import { useSidebar } from '@/contexts/SidebarContext';
import { useClient } from '@/contexts/ClientContext';

const Layout = ({ children }) => {
  const { sidebarCollapsed } = useSidebar();
  // Si falla /auth/bootstrap todo lo que cuelga del cliente activo sale vacío:
  // hay que decirlo en todas las pantallas, no dejar un panel mudo.
  const { bootstrapError, reloadBootstrap } = useClient();
  const { isTourOpen, tourMode, tourLength, startTour, closeTour } = useTour();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // NOTE: Auto-start tour disabled. The tour only opens when the user clicks
  // "Empezar tour guiado" from the OnboardingWizard widget or the navigation menu.

  return (
    <div className="min-h-screen bg-[var(--bg-surface)]">
      <Navigation onStartTour={startTour} />
      <CommandPalette />
      <OnboardingTour isOpen={isTourOpen} onClose={closeTour} mode={tourMode} length={tourLength} />
      <OnboardingWizard onStartTour={startTour} />
      <KeyboardShortcuts />

      {/* Main content area — A6: bg-surface (intermediate layer between sidebar/cards) */}
      <main className={`
        transition-all duration-300
        ml-0
        ${sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'}
        pt-16
        pb-20 lg:pb-4
        min-h-screen
        bg-[var(--bg-surface)]
      `}>
        <div className="px-4 lg:px-6 pt-2">
          <Breadcrumbs />
        </div>
        <div className="px-4 lg:px-6">
          <ErrorState message={bootstrapError} onRetry={reloadBootstrap} testId="client-bootstrap-error" className="mb-4" />
          {children}
        </div>
      </main>

      {/* Mobile bottom navigation */}
      <MobileBottomNav onMenuClick={() => setMobileMenuOpen(!mobileMenuOpen)} />

      {/* Copiloto flotante — visible en todas las páginas protegidas */}
      <CopilotWidget />
    </div>
  );
};

export default Layout;
